import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import {
	ContactsTable,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	RestService,
	TruckSearchTable,
} from 'cargo-chief-commons';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CarrierDataFeedbackDialog } from '../../project/capacity-search-panel/carrier-data-feedback/carrier-data-feedback.component';
import { AddContactFormDialog } from '../add-contact/add-contact.component';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { environment } from '@environment/environment';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { COMPARE } from '@domain/constants/functions';
import { CarrierFeedbackService } from '@service/carrierFeedback/carrier-feedback.service';

@Component({
	selector: 'app-carrier-contacts',
	templateUrl: './carrier-contacts.component.html',
	styleUrls: ['./carrier-contacts.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrierContactsComponent implements OnInit {
	@Input() contactList;
	@Input() carrierId;
	@Input() oldCarrierId;
	@Input() carrier;
	@Input() isCarrierProfile: boolean = false;
	@Input() editPrimaryContact: boolean = false;
	@Input() incorrectContactInfoEnabled: boolean = false;
	@Input() lane: TruckSearchTable;
	@Input() isEditContact: boolean = false;
	@Input() isCarrierUpdate: boolean = false;
	@Input() isCarrierLoggedIn: boolean = false;
	@Input() searchTruckForm = null;
	hasPrioritizedContact: boolean = false;

	@Output() updateContactsList: EventEmitter<any> = new EventEmitter();

	PAGE_SIZE = 10;
	totalNumberOfContacts = 0;

	contactsDataTable = new MatTableDataSource<ContactsTable>([]);
	displayedColumns = [
		'firstName',
		'lastName',
		'email',
		'phoneNumber',
		'primaryContact',
		'isMailReciever',
		'createdAt',
		'actions',
	];
	carrierProfileColumns = ['firstName', 'lastName', 'email', 'phoneNumber', 'mobileNumber'];

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		public dialog: MatDialog,
		private segmentWrapper: SegmentWrapperService,
		public cargochief: Cargochief,
		private carrierFeedbackService: CarrierFeedbackService
	) {}

	ngOnInit() {
		if (this.isCarrierProfile) {
			this.displayedColumns = [...this.carrierProfileColumns];
			if (this.editPrimaryContact) {
				this.displayedColumns.push('primaryContact');
			}
		}
		if (this.incorrectContactInfoEnabled) {
			this.displayedColumns.push('contactFeedback');
		}
		if (this.isEditContact) {
			this.displayedColumns.push('editColumn');
		}
		this.displayedColumns.push('reportColumn');
	}

	ngOnChanges() {
		this.buildDatatableView();
	}

	buildDatatableView() {
		this.hasPrioritizedContact = false;
		if (!this.utilService.isNullOrUndefined(this.contactList) && this.contactList.length > 0) {
			this.contactList.forEach((contact) => {
				if (contact.prioritizedContact) {
					this.hasPrioritizedContact = true;
				}
			});

			this.contactList = this.contactList.filter((contact: ContactsTable) => {
				if (
					IS_NOT_EMPTY(contact.firstName) ||
					IS_NOT_EMPTY(contact.lastName) ||
					IS_NOT_EMPTY(contact.email) ||
					IS_NOT_EMPTY(contact.phoneNumber) ||
					IS_NOT_EMPTY(contact.mobileNumber)
				) {
					return contact;
				}
			});
			this.sortContactList();
			this.contactsDataTable = new MatTableDataSource(this.contactList);
		} else {
			this.contactsDataTable = new MatTableDataSource([]);
		}
		this.totalNumberOfContacts = this.contactsDataTable.data.length;
		setTimeout(() => {
			this.initializeSortAndPage();
		});
	}

	initializeSortAndPage() {
		this.contactsDataTable.paginator = this.paginator;
		this.contactsDataTable.sort = this.sort;
	}

	sortContactList() {
		let prioritizedContactsList = [],
			contactsList = [];
		this.contactList.forEach((contact) => {
			if ((!this.hasPrioritizedContact && contact.primaryContact) || contact.prioritizedContact) {
				prioritizedContactsList.push(contact);
			} else {
				contactsList.push(contact);
			}
		});
		contactsList = contactsList.sort((a, b) => {
			if (IS_NOT_NULL_OR_UNDEFINED(a.firstName) && IS_NOT_NULL_OR_UNDEFINED(a.firstName)) {
				if (a.firstName.toLowerCase() === b.firstName.toLowerCase()) {
					if (IS_NOT_NULL_OR_UNDEFINED(a.lastName) && IS_NOT_NULL_OR_UNDEFINED(b.lastName)) {
						return COMPARE(a.lastName.toLowerCase(), b.lastName.toLowerCase(), true);
					}
					return -1;
				}
				return COMPARE(a.firstName.toLowerCase(), b.firstName.toLowerCase(), true);
			}
			return -1;
		});
		this.contactList = prioritizedContactsList.concat(contactsList);
	}

	primaryContactToggled(isPrimaryContact, contactId) {
		let updatedContact: ContactsTable = Object.assign(
				{},
				this.contactList.find((contact) => contact.contactId == contactId)
			),
			contact = Object.assign({}, updatedContact);
		contact.primaryContact = !isPrimaryContact;
		updatedContact.primaryContact = isPrimaryContact;
		this.fireContactEvent(true, updatedContact, contact);
		const url = this.urlService.updatePrimaryContact(isPrimaryContact, contactId, this.carrierId);
		this.restService.POST(url, {}).subscribe((result) => {});
	}

	isMailRecieverToggled(isPrimaryContact, contactId) {
		const url = this.urlService.updateIsMailReciever(isPrimaryContact, contactId, this.carrierId);
		this.restService.POST(url, {}).subscribe((result) => {});
	}

	contactFeedback(contact: ContactsTable) {
		const dialogRef = this.dialog.open(CarrierDataFeedbackDialog, {
			width: '900px',
			data: {
				lane: this.lane,
				incorrectDataType: 'contact',
				contact: contact,
			},
		});
	}

	openContactDialog(contact: ContactsTable) {
		const isEditContact = !this.utilService.isNullOrUndefined(contact);
		const dialogRef = this.dialog.open(AddContactFormDialog, {
			width: '500px',
			data: {
				carrierid: this.carrierId,
				isEdit: isEditContact,
				contact: contact,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				if (isEditContact) {
					const indexUpdated = this.contactList.findIndex((contact) => {
						return contact.contactId == result.contactId;
					});
					if (this.isCarrierUpdate) {
						this.fireContactEvent(isEditContact, result, this.contactList[indexUpdated]);
					}
					this.contactList[indexUpdated] = Object.assign({}, result);
				} else {
					this.fireContactEvent(isEditContact, result);
					this.contactList.unshift(result);
				}
				this.updateContactsList.emit(this.contactList);
			}
		});
	}

	fireContactEvent(
		isEditContact: boolean,
		updatedContact: ContactsTable,
		contact: ContactsTable = null
	) {
		if (this.isCarrierLoggedIn) {
			let changedProperties = {},
				eventName = SegmentEventsConstants.carrier_added_contact;
			if (isEditContact) {
				eventName = SegmentEventsConstants.carrier_updated_contact;
				Object.keys(updatedContact)
					.filter((k) => updatedContact[k] !== contact[k])
					.filter((key) => key != 'updatedAt')
					.filter((key) => {
						changedProperties[key] = updatedContact[key];
					});
				changedProperties = JSON.stringify(changedProperties)
					.replace(/\"/g, '')
					.replace(/\{/g, '')
					.replace(/\}/g, '');
			} else {
				changedProperties = `New contact added`;
			}
			const payload: any = {
				contact: updatedContact,
				carrier: this.cargochief.CARRIER,
				url: `${environment.clientUrl}admin/carrier_profile/${this.carrierId}`,
				updated: changedProperties,
			};
			this.segmentWrapper.fireSegmentEvent(eventName, payload);
		}
	}

	async reportDataAction(dataType: string) {
		await this.carrierFeedbackService.reportDataAction(dataType, this.searchTruckForm, this.lane);
	}
}
